import { convertToBigNumber } from '@paradigm/utils/formatDecimal';
import { NEGATIVE_SIGN } from '@paradigm/utils/src/enhanceNegativeSign';

export interface Greeks {
  readonly delta: string;
  readonly gamma: string;
  readonly mark_price?: string;
  readonly theta: string;
  readonly vega: string;
}

export const GREEKS_PRECISION = {
  delta: 2,
  gamma: 5,
  vega: 2,
  theta: 2,
};

export const EMPTY_GREEKS: Greeks = {
  delta: '',
  gamma: '',
  mark_price: '',
  theta: '',
  vega: '',
};

function formatValue(value?: string | null, precision?: number) {
  if (value == null) return NEGATIVE_SIGN;
  return convertToBigNumber(value).toFormat(precision);
}

export function formatDelta(value: string | undefined) {
  return formatValue(value, GREEKS_PRECISION.delta);
}

export function formatGamma(value: string | undefined) {
  return formatValue(value, GREEKS_PRECISION.gamma);
}

export function formatVega(value: string | undefined) {
  return formatValue(value, GREEKS_PRECISION.vega);
}

export function formatTheta(value: string | undefined) {
  return formatValue(value, GREEKS_PRECISION.theta);
}
